// Central site-wide constants
export const SITE = {
  phone: '+919632406669',
  phoneDisplay: '+91 96324 06669',
  email: 'editingschoolbengaluru@gmail.com',
  whatsappNumber: '919632406669',
  whatsappMessage:
    'Hi Film Editor Soundarraj sir, I want to know more about the editing course. Could you please share more details?',
  hiringPartnersMessage:
    'Hi Film Editor Soundarraj sir, our team is looking to hire certified video editors from MatchFrame. Could you share details about your placement process?',
  googleReviewsUrl: 'https://share.google/7UErmQy7fH1KdKLKd',
  copyrightLine:
    '© 2026 MatchFrame Editing School Bangalore, a Unit of PRS Multimedia LLP. All rights reserved.',
};

export const STATS = [
  { num: '750+', text: 'Students Trained' },
  { num: '500+', text: 'Students Placed' },
  { num: '125+', text: 'Hiring Partners' },
  { num: '25+', text: 'Years Experience' },
];

export const getWhatsAppUrl = (message = SITE.whatsappMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
